export const cropOptions = [
    {
        title: 'crop.custom',
        value: 'custom',
        options: [
            {
                title: 'crop.custom',
                value: 'custom',
                aspectRatio: NaN,
                styles: 'width: 67px;height: 67px;border-style: dashed;',
                classes: 'bg-transparent border border-dashed border-2 border-gray-500 drop-shadow-sm',
                placeholder: '',
            },
        ],
    },
    {
        title: 'Instagram',
        value: 'instagram',
        options: [
            {
                title: 'crop.square',
                value: 'instagram_square',
                aspectRatio: 1,
                styles: 'width: 67px;height: 67px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '1:1',
            },
            {
                title: 'crop.landscape',
                value: 'instagram_landscape',
                aspectRatio: 1.91 / 1,
                styles: 'width: 67px;height: 35px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '1.91:1',
            },
            {
                title: 'crop.portrait',
                value: 'instagram_portrait',
                aspectRatio: 4 / 5,
                styles: 'width: 54px;height: 67px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '4:5',
            },
            {
                title: 'crop.story',
                value: 'instagram_story',
                aspectRatio: 9 / 16,
                styles: 'width: 44px;height: 67px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '9:16',
            },
        ],
    },
    {
        title: 'Facebook',
        value: 'facebook',
        options: [
            {
                title: 'crop.post',
                value: 'facebook_post',
                aspectRatio: 1.91 / 1,
                styles: 'width: 67px;height: 35px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '1.91:1',
            },
            {
                title: 'crop.carousel',
                value: 'facebook_carousel',
                aspectRatio: 1,
                styles: 'width: 67px;height: 67px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '1:1',
            },
        ],
    },
    {
        title: 'Twitter',
        value: 'twitter',
        options: [
            {
                title: 'crop.post',
                value: 'twitter_post',
                aspectRatio: 2 / 1,
                styles: 'width: 67px;height: 34px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '2:1',
            },
        ],
    },
    {
        title: 'Linkedin',
        value: 'linkedin',
        options: [
            {
                title: 'crop.post',
                value: 'linkedin_post',
                aspectRatio: 1.91 / 1,
                styles: 'width: 67px;height: 35px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '1.91:1',
            },
        ],
    },
    {
        title: 'crop.commonAspectRatio',
        value: 'common_aspect_ratio',
        options: [
            {
                title: '1:1',
                value: 'common_aspect_ratio_1_1',
                aspectRatio: 1,
                styles: 'width: 67px;height: 67px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '',
            },
            {
                title: '5:4',
                value: 'common_aspect_ratio_5_4',
                aspectRatio: 5 / 4,
                styles: 'width: 67px;height: 59px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '',
            },
            {
                title: '4:3',
                value: 'common_aspect_ratio_4_3',
                aspectRatio: 4 / 3,
                styles: 'width: 67px;height: 55px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '',
            },
            {
                title: '3:2',
                value: 'common_aspect_ratio_3_2',
                aspectRatio: 3 / 2,
                styles: 'width: 67px;height: 50px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '',
            },
            {
                title: '16:9',
                value: 'common_aspect_ratio_16_9',
                aspectRatio: 16 / 9,
                styles: 'width: 67px;height: 40px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '',
            },
            {
                title: '1.91:1',
                value: 'common_aspect_ratio_191_1',
                aspectRatio: 1.91 / 1,
                styles: 'width: 67px;height: 35px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '',
            },
            {
                title: '4:5',
                value: 'common_aspect_ratio_4_5',
                aspectRatio: 4 / 5,
                styles: 'width: 54px;height: 67px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '',
            },
            {
                title: '3:4',
                value: 'common_aspect_ratio_3_4',
                aspectRatio: 3 / 4,
                styles: 'width: 50px;height: 67px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '',
            },
            {
                title: '2:3',
                value: 'common_aspect_ratio_2_3',
                aspectRatio: 2 / 3,
                styles: 'width: 45px;height: 67px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '',
            },
            {
                title: '9:16',
                value: 'common_aspect_ratio_9_16',
                aspectRatio: 9 / 16,
                styles: 'width: 44px;height: 67px;border-style: dashed;',
                classes: 'bg-gray-500 border border-dashed border-gray-500 drop-shadow-sm',
                placeholder: '',
            },
        ],
    },
];
